(($, Drupal, drupalSettings) => {

  Drupal.behaviors.frontpageappoitments = {
    attach: (context, settings) => {
      const openURL = (url, target = '_blank') => {
        var link = document.createElement('a');
        link.target = target;
        link.href = url;
        link.rel = "noopener noreferrer";
        document.body.appendChild(link); // you need to add it to the DOM to get FF working
        link.click();
        link.parentNode.removeChild(link); // link.remove(); doesn't work on IE11
      };
      // $(context.querySelectorAll('.front-dropdown')).once('frontpageInit').each( (index, item) => {
      $(once('frontpageInit', '.front-dropdown')).each( (index, item) => {
        const navigateData = JSON.parse(item.dataset.selections),
              appointmentEl = item.querySelector('.appointment'),
              tolistingsEl = item.querySelector('.tolistings');
        delete item.dataset.selections;
        appointmentEl.addEventListener('click', e => {
          openURL("https://plus.plusterveys.fi/ajanvaraus");
        });

        tolistingsEl.addEventListener('click', e => {
          window.location.href = '/hammashoito/hammaslaakaritoimipisteet';
        })
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
